<template>
  <Head title="New Site" />
  <DashboardLayout>
    <DContainer fluid>
      <DRow class="mb-4">
        <DCol>
          <div class="d-flex align-items-center gap-3">
            <Link href="/sites" class="btn btn-link text-dark p-0">
              <i-bi-arrow-left style="width: 24px; height: 24px" />
            </Link>
            <div>
              <h1 class="h3 mb-1">New Site</h1>
              <p class="text-muted mb-0">Register an already-provisioned editor</p>
            </div>
          </div>
        </DCol>
      </DRow>

      <DRow>
        <DCol lg="8" xl="6">
          <div class="alert alert-info d-flex gap-2 align-items-start small">
            <i-bi-info-circle class="flex-shrink-0 mt-1" style="width: 16px; height: 16px" />
            <div class="alert-body">
              <strong>This form registers an editor that already exists</strong> — it
              adds the site to the dashboard for monitoring and link-outs; it does not
              provision anything.
              <div class="mt-2">
                To stand up a <em>new</em> hosted editor, run the provisioning script
                from the ops repo — it creates the instance end-to-end and registers
                it here automatically, so you won't need this form:
              </div>
              <pre class="mb-0 mt-2 p-2 bg-body-tertiary rounded"><code>cd ~/Code/cloudship/astroadmin-ops
hosts/scripts/add-site.sh &lt;slug&gt; --repo &lt;owner&gt;/&lt;repo&gt; --public-url https://…</code></pre>
            </div>
          </div>

          <DCard class="border-0 shadow-sm">
            <SiteForm />
          </DCard>
        </DCol>
      </DRow>
    </DContainer>
  </DashboardLayout>
</template>

<script setup lang="ts">
import { Link, Head } from "@inertiajs/vue3";
import {
  DContainer,
  DRow,
  DCol,
  DCard,
} from "@omnitend/dashboard-for-laravel";
import DashboardLayout from "../../Layouts/DashboardLayout.vue";
import SiteForm from "./Form.vue";
</script>

<style scoped>
/* Flex children default to min-width:auto, so the long one-line <pre>
   sets the child's intrinsic width and overflows the alert. Let the
   child shrink and scroll the command instead. */
.alert-body {
  min-width: 0;
}

.alert-body pre {
  overflow-x: auto;
}
</style>
